module.exports = __webpack_public_path__ + "static/media/totalUsers.236e92c6.png";